/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('revenueProductionService', revenueProductionService);

    revenueProductionService.$inject = ['$http', 'CONFIG', 'messageService'];

    function revenueProductionService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API ;
        var service = {
            updateSegmentItineraries: updateSegmentItineraries,
            updateSegmentItinerariesConnectionSsr: updateSegmentItinerariesConnectionSsr,
            updateOversold: updateOversold,
            getActivateDeactivateClass: getActivateDeactivateClass,
            updateActivateDeactivateClass: updateActivateDeactivateClass,
            getOverSoldAll: getOverSoldAll
        }

        return service;

        function updateSegmentItineraries(segmentItineraries, userLogin){
            return $http.put(urlBase + "/segmentClasses/updateAll?user_login=" + userLogin , segmentItineraries)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(error){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }

        function updateSegmentItinerariesConnectionSsr(segmentItineraries){
            return $http.put(urlBase + "/segmentFlightSsr/updateAll" , segmentItineraries)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(error){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }

        function updateOversold(oversold, userLogin){
            return $http.put(urlBase + "/segmentClasses/overSoldAll?user_login=" + userLogin , oversold)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(error){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }

        function getActivateDeactivateClass(departureDate, departureFlightId){
            return $http.get(urlBase + "/segmentFlight/activeDisableAll/" + departureDate + "/" + departureFlightId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateActivateDeactivateClass(save, userLogin){
            return $http.put(urlBase + "/segmentClasses/activeDisableAll?user_login=" + userLogin, save)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(error){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }

        function getOverSoldAll(segmentFlightId){
            return $http.get(urlBase + "/segmentFlight/overSoldAll/" + segmentFlightId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

    }

})();

